import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { AppComponent } from './app.component';
import { AddOptionComponent } from './components/add-option/add-option.component';
import { CartPaymentComponent } from './components/cart-payment/cart-payment.component';
import { CartStepsComponent } from './components/cart-steps/cart-steps.component';
import { ContinueDialogComponent } from './components/continue-dialog/continue-dialog.component';
import { ErrorCardComponent } from './components/error-card/error-card.component';
import { MainComponent } from './components/main/main.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PriceComponent } from './components/price/price.component';
import { ProductItemComponent } from './components/product-item/product-item.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { BookingService } from './services/booking.service';
import { CartService } from './services/cart/cart.service';
import { DialogService } from './services/dialog.service';
import { RollbarErrorHandler, rollbarFactory, RollbarService } from './services/rollbar.service';
import { StorageService } from './services/storage.service';
import { MaterialModule } from './shared/material.module';
import { SharedModule } from './shared/shared.module';
import { OptionsListComponent } from './components/options-list/options-list.component';
import { CartComponent } from './components/cart/cart.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { StripeService } from './services/stripe.service';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { AppCurrencyPipe } from './pipes/app-currency.pipe';
import { FailedBookingDialogComponent } from './components/failed-order-dialog/failed-order-dialog';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductItemService } from './components/product-item/product-item.service';

const appRoutes: Routes = [
  {
    path: 'id/:id',
    component: MainComponent,
  },
  {
    path: 'list',
    component: OptionsListComponent,
  },
  {
    path: 'list/cart',
    component: CartComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  declarations: [
    AppComponent,
    AddOptionComponent,
    ProductItemComponent,
    TruncatePipe,
    AppCurrencyPipe,
    CartComponent,
    CartStepsComponent,
    CartPaymentComponent,
    ContinueDialogComponent,
    FailedBookingDialogComponent,
    MainComponent,
    NotFoundComponent,
    ErrorCardComponent,
    PriceComponent,
    OptionsListComponent,
    DateRangePickerComponent,
    NavbarComponent,
    FooterComponent,
    DatePickerComponent,
  ],
  imports: [
    MatMomentDateModule,
    BrowserAnimationsModule,
    NgbPopoverModule,
    RouterModule.forRoot(appRoutes),
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    BookingService,
    StripeService,
    CartService,
    StorageService,
    ProductItemService,
    DialogService,
    {
      provide: ErrorHandler,
      useClass: RollbarErrorHandler,
    },
    {
      provide: RollbarService,
      useFactory: rollbarFactory,
    },
  ],
  bootstrap: [AppComponent],
  entryComponents: [ContinueDialogComponent, FailedBookingDialogComponent],
})
export class AppModule {}
